import { render, staticRenderFns } from "./MyWorkOrderTabPage.vue?vue&type=template&id=cdc348be&scoped=true"
import script from "../MyWorkOrders/MyWorkOrderTabPage.js?vue&type=script&lang=js&external"
export * from "../MyWorkOrders/MyWorkOrderTabPage.js?vue&type=script&lang=js&external"
import style0 from "./MyWorkOrderTabPage.vue?vue&type=style&index=0&id=cdc348be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc348be",
  null
  
)

export default component.exports